export interface UpdateDecisionTreeVersionDefinition{
	comment: string;
	json: string;
	production_ready: boolean;
	id: string;
}